var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzure(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.987,
    height: 24.984,
    viewBox: "0 0 29.987 24.984",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    transform: "translate(-217 -851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "azure-svgrepo-com",
    transform: "translate(357.184 840.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    d: "M0,10.672Z",
    transform: "translate(-123.763 0)",
    fill: "#0089d6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "azure-icon-svgrepo-com",
    transform: "translate(-140.184 12.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    "data-name": "Path 1846",
    d: "M13.873,21.987c3.853-.681,7.035-1.244,7.071-1.252l.067-.014-3.637-4.327c-2-2.38-3.637-4.336-3.637-4.347s3.756-10.364,3.777-10.4c.007-.012,2.563,4.4,6.2,10.7l6.231,10.8.047.083H18.428l-11.56,0,7-1.237ZM0,20.667c0-.006,1.714-2.981,3.809-6.612l3.809-6.6,4.438-3.725C14.5,1.682,16.5,0,16.509,0a.772.772,0,0,1-.071.18l-4.82,10.338L6.884,20.67l-3.442,0c-1.893,0-3.442,0-3.442-.007Z",
    transform: "translate(0 0)",
    fill: "#0089d6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/azure.963c9f4204057b3d7374307e5c53fb1c.svg";
export { ForwardRef as ReactComponent };